import { Theme } from '@mui/material';

export const navLinkStyle = (theme: Theme) => ({
  fontWeight: 'normal',
  color: theme.palette.text.subdued,
  display: 'inline',
  textDecoration: 'none',
});

export const activeLinkStyle = (theme: Theme) => ({
  ...navLinkStyle,
  textDecoration: 'none',
  borderBottom: `2px solid ${theme.palette.accent.secondary}`,
  color: theme.palette.text.main,
  fontWeight: theme.typography.fontWeightBold,
});

export const navBoxStyle = {
  margin: {
    xs: '0 10px',
    md: '0 12px',
    lg: '0 20px',
  },

  // special because our menu is so big.. we want something between sm and md
  '@media (max-width: 1015px)': {
    margin: '0 10px',
  },
  '@media (max-width: 990px)': {
    margin: '0 8px',
  },
};
